/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import { isString } from 'lodash';

import { LAST_REQUEST_TIME } from 'services/Auth';
import { RECEIVED_SSO_AUTHENTICATION } from './AuthActions';

export const initialLastRequestTime = Date.now();

export const lastRequestTimeReducer = (state = {}, action) => {
  if (!isString(action.type)) {
    return state;
  }

  const isReceivedActionType = action.type.startsWith('RECEIVED');

  if (isReceivedActionType) {
    const currentTime = Date.now();
    const currentLocalStorage = localStorage.getItem(LAST_REQUEST_TIME);

    if (currentLocalStorage > currentTime) {
      return currentLocalStorage;
    }
    localStorage.setItem(LAST_REQUEST_TIME, currentTime);

    return currentTime;
  }

  return state;
};

export const ssoAuthentication = (state = {}, action) => {
  // TODO : support error state

  if (action.type !== RECEIVED_SSO_AUTHENTICATION) {
    return state;
  }

  const { token } = action;
  return {
    ...state,
    token
  };
};
